<app-menu></app-menu>
<div class="appContentsContainer">
  <form
    [formGroup]="printParams"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm wrapHalfRows"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle">
        {{ "printParams.title" | translate }}
      </div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="glValor">Nombre Fichero</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="glValor" maxlength="128" />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>
      <div class="formGroupButtons detalleFormGroupButtonsFooter">
        <div class="formButton">
          <button
            class="submitButton"
            type="button"
            *ngIf="printParams.pristine"
            (click)="goPredefinedMailBox()"
          >
            <em class="fas fa-times fa-2x backButtonAlign"></em>
          </button>
          <button
            class="submitButton"
            *ngIf="!printParams.pristine"
            [swal]="confirmSwal"
            type="button"
          >
            <em class="fas fa-times fa-2x backButtonAlign"></em>
          </button>
        </div>

        <div class="formButton middleButtonAceptarContainer">
          <div class="middleButtonAceptar formButton">
            <button type="submit" class="submitButton">
              {{ "commons.ok" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goPredefinedMailBox()"
    >
    </swal>
  </form>
</div>
